"use client";

import { LogoutDialog as SharedLogoutDialog, useMainAppLayout } from "@osn/react-components";
import { useLogout } from "./use-logout";

export default function LogoutDialog() {
  const { tenantData } = useMainAppLayout();
  const logout = useLogout();

  return <SharedLogoutDialog appName={tenantData?.name} onLogout={logout} />;
}
